import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiPackage, FiActivity, FiBarChart3, FiScan, FiUsers, FiFileText, FiGlobe, FiBox } = FiIcons;

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: FiHome },
  { name: 'Products', href: '/products', icon: FiPackage },
  { name: 'Pallets', href: '/pallets', icon: FiBox }, // Added Pallets
  { name: 'Sales Listings', href: '/sales-listings', icon: FiGlobe },
  { name: 'Scanner', href: '/scanner', icon: FiScan },
  { name: 'Sales Report', href: '/sales-report', icon: FiFileText },
  { name: 'History', href: '/history', icon: FiActivity },
  { name: 'Users', href: '/users', icon: FiUsers },
];

const Sidebar = () => {
  return (
    <div className="w-64 bg-white dark:bg-gray-800 shadow-lg transition-colors duration-200 flex flex-col h-full border-r border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-center h-16 px-4 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <img 
          src="https://s3.us-east-2.wasabisys.com/crc-cdn/crc/InventraQ%20-Logo.png" 
          alt="InventraQ Logo" 
          className="h-10 w-auto object-contain dark:invert dark:brightness-200" 
        />
      </div>
      <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 ${
                isActive
                  ? 'bg-blue-50 dark:bg-gray-700 text-blue-700 dark:text-blue-400 border-r-2 border-blue-700 dark:border-blue-400'
                  : 'text-gray-700 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-200'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <SafeIcon
                  icon={item.icon}
                  className={`mr-3 h-5 w-5 ${
                    isActive ? 'text-blue-700 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'
                  }`}
                />
                {item.name}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;